import { i18n } from '../../i18n/i18n';

const defaults = {
  title: i18n.t('CONFIRM'),
  message: i18n.t('ARE_YOU_SURE'),
  confirmMessage: i18n.t('YES'),
  rejectMessage: i18n.t('NO'),
  onConfirm: null,
  onReject: null,
};

const state = {
  showConfirm: false,
  options: {},
  defaults,
};

const actions = {
  showConfirm({ commit }, payload) {
    commit('confirmShow', payload);
  },

  hideConfirm({ commit }) {
    commit('confirmHide');
  },

  confirm({ commit, state }) {
    if (state.options.onConfirm) {
      state.options.onConfirm();
    }
    commit('confirmHide');
  },

  reject({ commit, state }) {
    if (state.options.onReject) {
      state.options.onReject();
    }
    commit('confirmHide');
  },

  clearConfirm({ commit }) {
    commit('confirmHide');
    commit('setDefaults');
  },
};

const mutations = {
  confirmShow(state, payload) {
    state.showConfirm = true;
    state.options = { ...state.defaults, ...payload };
  },

  confirmHide(state) {
    state.showConfirm = false;
    state.options = {};
  },

  setDefaults(state) {
    state.defaults = defaults;
  },
};

export const confirm = {
  namespaced: true,
  state,
  actions,
  mutations,
};
